import { faGavel } from '@fortawesome/pro-regular-svg-icons/faGavel';
import { AUCTION_CATEGORIES } from '@propertypal/shared/src/constants/filterOptions';
import { PropertySearchResult } from '@propertypal/shared/src/types/propertySearch';
import { Filters } from '@propertypal/shared/src/utils/search/getNlpFilters';
import {
  getOpeningViewsUrl,
  getShowHomeTimesUrl,
  getTermParam,
} from '@propertypal/shared/src/utils/search/getOpenViewingsContent';
import { capitalize } from '@propertypal/shared/src/utils/text';
import CalendarIcon from '@propertypal/web-ui/src/calendar/CalendarIcon';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import React, { FunctionComponent } from 'react';
import { Container, Pill } from './OpenShowPills.style';

interface Props {
  searchResult?: PropertySearchResult;
  filters: Filters;
}

const OpenShowPills: FunctionComponent<Props> = (props) => {
  const showAuctions = AUCTION_CATEGORIES.includes(props.filters.category || '');

  if (
    !props.searchResult ||
    (!showAuctions && !props.searchResult?.nextOpenViewingTime && !props.searchResult?.nextShowHomeOpenTime)
  ) {
    return null;
  }

  const { nextOpenViewingTime, nextShowHomeOpenTime, params } = props.searchResult;
  const term = getTermParam(props.searchResult);

  return (
    <Container data-testid="open-viewing-box">
      {nextOpenViewingTime && (
        <Pill href={getOpeningViewsUrl(params, nextOpenViewingTime)}>
          <CalendarIcon containerStyle={{ transform: 'scale(0.75)' }} mode="black" date={nextOpenViewingTime} />

          <span>Open Viewings {term ? `in ${capitalize(term)}` : ''}</span>

          <button type="button">View</button>
        </Pill>
      )}

      {nextShowHomeOpenTime && (
        <Pill href={getShowHomeTimesUrl(term)}>
          <CalendarIcon containerStyle={{ transform: 'scale(0.75)' }} mode="black" date={nextShowHomeOpenTime} />

          <span>Show Homes {term ? `in ${capitalize(term)}` : ''}</span>

          <button type="button">View</button>
        </Pill>
      )}

      {showAuctions && (
        <Pill href="/upcoming-auctions" data-testid="upcoming-auctions-box">
          <FontAwesomeIcon icon={faGavel} size={24} style={{ margin: '0 5px' }} />

          <span>Upcoming Auctions</span>

          <button type="button">View</button>
        </Pill>
      )}
    </Container>
  );
};

export default OpenShowPills;
